import { Popup } from 'devextreme-react/popup';
import React, { FC } from 'react';
import { ActionButton, HeadingItem } from 'components';
import { faThumbsUp } from '@fortawesome/pro-solid-svg-icons';
import { EQUIPMENT_MAX_QUANTITY } from 'utils';
import './equipment-quantity-pop-up.scss';

type Props = {
  isVisible: boolean,
  onClickOk: () => void
}

export const EquipmentQuantityPopup: FC<Props> = ({ isVisible, onClickOk }) => {
  return (
    <Popup
      visible={isVisible}
      dragEnabled={false}
      closeOnOutsideClick={false}
      showCloseButton={true}
      showTitle={false}
      width={300}
      height={200}
    >
      <div className="equipment-quantity-pop-up-card">
        <HeadingItem text={'Maximum Quantity Exceeded'}></HeadingItem>
        <div className="equipment-quantity-pop-up-content">
          <p>The return maximum is <b>{EQUIPMENT_MAX_QUANTITY}</b></p>
          <p>Please enter a lower return quantity</p>
        </div>
        <div className="bottom-fix-action-row">
          <ActionButton
            icon={faThumbsUp}
            buttonColor={'#FF0000'}
            onClick={onClickOk}
            buttonText={'Ok'} />
        </div>
      </div>
    </Popup>
  )
}